// extracted by mini-css-extract-plugin
module.exports = {"SearchWrapper__search-container__3Hh1s":"SearchWrapper__search-container__3Hh1s"};